import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import DeleteMultipleClosedTicketsModal, { MultipleClosedTicketsRef } from './DeleteMultipleClosedTicketsModal';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import { FeaturePermission } from 'constants/Permission';
import Button from 'components/Button';
import VoidedBtnV2 from 'assets/Icons/voidedBtnV2';

const RevokedButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement> & { selectedRowKeys: string[]; onSuccess: () => void },
) => {
  const openDeleteMultipleClosedTicketsModal = useRef<MultipleClosedTicketsRef>(null);
  const [visiblePW, setVisiblePW] = useState(false);
  const dispatch = useAppDispatch();

  const showRequestAdminLocalPW = () => {
    setVisiblePW(true);
  };

  const onDeleteMultipleClosedTicketsSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
    props.onSuccess();
  };

  const onVerifyAdminSuccess = (pin?: string, staffDataVerified?: IStaffItemData) => {
    setVisiblePW(false);
    const billIds = props.selectedRowKeys;
    const data = {
      billIds: billIds,
      staffDeleteId: staffDataVerified?.id || '',
    };
    openDeleteMultipleClosedTicketsModal.current?.open(data, onDeleteMultipleClosedTicketsSuccess);
  };

  return (
    <Container>
      <Button ntype='PRIMARY' onClick={showRequestAdminLocalPW} cardCashier height={3} iconElement={<VoidedBtnV2 fill='#FFF' width={28} height={28} />}>
        Revoked
      </Button>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2={true}
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
          featureCode={FeaturePermission.DELETE_TICKET}
        />
      )}
      <DeleteMultipleClosedTicketsModal ref={openDeleteMultipleClosedTicketsModal} />
    </Container>
  );
};

export default RevokedButton;

const Container = styled.div`
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;